import React, { useMemo, useState, useEffect } from 'react';
import moment from 'moment';
import { createFormatDateWithContext, createFormatDateTimeWithContext, } from 'utils/formatters/Date';
const LocaleContext = React.createContext();
const defaultLocaleData = {
    dateFormat: DEFAULT_DATE_FORMAT,
    verbalDateFormat: VERBAL_DATE_FORMAT,
    dimensional_units: DEFAULT_DIMENSIONAL_UNITS,
    weight_units: DEFAULT_WEIGHT_UNITS,
    distance_units: DEFAULT_DISTANCE_UNITS,
    currency: DEFAULT_CURRENCY,
    temperatureUnits: DEFAULT_TEMPERATURE_UNITS,
    timeFormat: DEFAULT_TIME_FORMAT,
    verbalTimeFormat: VERBAL_TIME_FORMAT,
    localeCode: LOCALE_CODE,
    is24HourFormat: IS_24_HOUR_FORMAT,
};
const LocaleContextProvider = (props) => {
    const [languageCodeId, setLanguageCodeId] = useState(defaultLocaleData.localeCode);
    /*
     * moment's locale gets set globally here anytime the
     * languageCodeId changes to localize date format in
     * all children components
     *
     * https://momentjs.com/docs/#/i18n/
     */
    useEffect(() => {
        moment.locale(languageCodeId);
    }, [languageCodeId]);
    const localeData = Object.assign({}, defaultLocaleData);
    const formatDateTime = createFormatDateTimeWithContext({
        dateFormat: defaultLocaleData.dateFormat,
        timeFormat: defaultLocaleData.timeFormat,
    });
    const formatDate = createFormatDateWithContext({
        dateFormat: defaultLocaleData.dateFormat,
    });
    const formatDateTimeVerbal = createFormatDateTimeWithContext({
        dateFormat: defaultLocaleData.verbalDateFormat,
        timeFormat: defaultLocaleData.verbalTimeFormat,
    });
    const formatDateVerbal = createFormatDateWithContext({
        dateFormat: defaultLocaleData.verbalDateFormat,
    });
    const value = useMemo(() => ({
        localeData,
        languageCodeId,
        setLanguageCodeId,
        formatDate,
        formatDateTime,
        formatDateVerbal,
        formatDateTimeVerbal,
    }), [languageCodeId]);
    return (React.createElement(LocaleContext.Provider, { value: value }, props.children));
};
/*
 * We need this HOC for class components to pass data through props
 */
const withLocaleContext = (Component) => (props) => (React.createElement(LocaleContext.Consumer, null, (regionContextProps) => (React.createElement(Component, Object.assign({}, props, regionContextProps)))));
export { LocaleContext, LocaleContextProvider, withLocaleContext };
